import Vue from 'vue'
import Router from 'vue-router'


//routes
import defaultRoutes from './default';
//import horizontalRoutes from './horizontal';
//import boxedRoutes from './boxed';
//import mini from './mini';
//import boxedV2 from './boxed-v2';

const Login = () => import('Views/auth/Login');

Vue.use(Router)

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/login',
            component: Login,
            meta: {
                requiresAuth: false
            }
        },
        defaultRoutes
		//horizontalRoutes,
		//boxedRoutes,
        //mini
		//boxedV2
	]
})
